import React from "react";

import { Stack, SxProps } from "@mui/material";

const ProductFeatureList = ({
  children,
  sx,
}: {
  children: React.ReactNode;
  sx?: SxProps;
}) => {
  return (
    <Stack spacing={1} sx={sx}>
      {children}
    </Stack>
  );
};

export default ProductFeatureList;
